import script from "./CoursesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CoursesTable.vue?vue&type=script&setup=true&lang=js"

import "./CoursesTable.vue?vue&type=style&index=0&id=6b995936&lang=css"

const __exports__ = script;

export default __exports__